export default function formatTimestampToMonthYear(dateString, addDays = 0) {
  const date = new Date(dateString);
  date.setDate(date.getDate() + addDays);
  const options = { month: "short", day: "numeric", year: "numeric" };
  return date.toLocaleDateString("en-US", options);
}
